
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaioutstationcab() {



    const cardData =
    {
        keyword: 'Mumbai Outstation Cabs',
        heading: 'S9 Travels: Mumbai Outstation Cabs',
        headingDescription: 'S9 Travels offers reliable and comfortable Mumbai outstation cab services, ensuring a smooth and hassle-free journey to your destination. Whether you are planning a weekend getaway, a business trip, or a family vacation, our well-maintained cabs and professional drivers guarantee a safe and enjoyable ride. With flexible booking options, comfortable seating, and top-notch customer service, S9 Travels makes your outstation travel from Mumbai seamless and stress-free.',

        top: 'Top Places to Visit in Mumbai with S9 Travels',

        "topPlaces": [
            {
                "title": "Gateway of India",
                "description": "The Gateway of India is an iconic symbol of Mumbai. This majestic archway was built to commemorate the visit of King George V and Queen Mary in 1911. Located on the waterfront, it’s a perfect spot for photography and to take in the beautiful views of the Arabian Sea."
            },
            {
                "title": "Marine Drive",
                "description": "Marine Drive, also known as the Queen's Necklace, is a stunning boulevard that stretches along the coastline. It’s famous for its beautiful sunset views and is a popular place for an evening stroll, offering a great vantage point of the city's skyline."
            },
            {
                "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
                "description": "This UNESCO World Heritage Site is one of Mumbai's most famous landmarks. Known for its Victorian Gothic architectural style, CST is a historic railway station and a must-visit for history and architecture enthusiasts."
            },
            {
                "title": "Elephanta Caves",
                "description": "A short ferry ride from the city takes you to Elephanta Island, where you can explore ancient rock-cut caves with stunning sculptures dedicated to Lord Shiva. The caves are a UNESCO World Heritage Site and offer a blend of art, history, and natural beauty."
            },
            {
                "title": "Colaba Causeway",
                "description": "Colaba Causeway is a vibrant shopping street where you can find everything from clothes, jewelry, and antiques to local handicrafts. It’s also home to a range of cafes and restaurants, making it a popular spot for tourists and locals alike."
            },
            {
                "title": "Bandra-Worli Sea Link",
                "description": "This stunning bridge is an engineering marvel and offers panoramic views of the Arabian Sea and Mumbai’s skyline. A drive across the Bandra-Worli Sea Link is an unforgettable experience, especially during the evening when the bridge is beautifully lit."
            },
            {
                "title": "Juhu Beach",
                "description": "Juhu Beach is one of Mumbai’s most famous beaches, popular for its relaxed atmosphere, food stalls, and lively crowds. It’s the perfect spot to enjoy a beach day, watch the sunset, or savor local street food like pav bhaji and bhel puri."
            },
            {
                "title": "Haji Ali Dargah",
                "description": "The Haji Ali Dargah is a beautiful mosque and tomb located on an islet in the Arabian Sea. This iconic structure is both a spiritual and architectural marvel, offering a serene and peaceful experience for visitors."
            },
            {
                "title": "Sanjay Gandhi National Park",
                "description": "Escape the hustle and bustle of Mumbai and visit Sanjay Gandhi National Park, located on the outskirts of the city. The park offers a green oasis with walking trails, a lake, and the famous Kanheri Caves, providing an ideal retreat for nature lovers."
            },
            {
                "title": "Chor Bazaar",
                "description": "Known as the 'Thieves Market,' Chor Bazaar is a bustling street market in the heart of Mumbai. It’s the place to go if you’re looking for vintage items, antiques, or unique collectibles at bargain prices."
            }
        ],

        "services": [
            {
                "name": "Mumbai Outstation Cab Service",
                "description": "Book a reliable and comfortable outstation cab service from Mumbai. Whether you're traveling for business, leisure, or a family trip, we provide safe and convenient taxis to your destination."
            },
            {
                "name": "Book Outstation Taxi from Mumbai",
                "description": "Booking an outstation taxi from Mumbai is easy and quick. Choose from a variety of vehicles and enjoy a stress-free journey to your destination with professional drivers."
            },
            {
                "name": "Affordable Outstation Cabs from Mumbai",
                "description": "Our affordable outstation cab service from Mumbai ensures that you travel in comfort and style without breaking the bank. Get great value for money for your outstation trips."
            },
            {
                "name": "Private Outstation Taxis from Mumbai",
                "description": "Looking for privacy and comfort on your outstation trip? Book a private outstation taxi from Mumbai and enjoy a personalized travel experience with your friends, family, or colleagues."
            },
            {
                "name": "One-Way Outstation Cabs from Mumbai",
                "description": "Need a one-way ride for your outstation journey from Mumbai? Our one-way outstation cabs provide a convenient and affordable option for single trips to various destinations."
            },
            {
                "name": "Round Trip Outstation Cabs from Mumbai",
                "description": "For a round-trip outstation journey from Mumbai, book our round-trip cabs. This service ensures a hassle-free and timely return from your destination."
            },
            {
                "name": "Group Travel in Outstation Cabs from Mumbai",
                "description": "Traveling with a group? Our spacious outstation cabs are ideal for group travel from Mumbai. With ample space for passengers and luggage, everyone can travel together comfortably."
            },
            {
                "name": "Comfortable Outstation Travel by Taxi from Mumbai",
                "description": "Enjoy a comfortable outstation journey by taxi from Mumbai. Our well-maintained cabs and professional drivers ensure that your travel experience is smooth, safe, and enjoyable."
            },
            {
                "name": "Mumbai to Outstation Trip by Taxi",
                "description": "Whether you're traveling to a nearby town or a distant city, book a taxi for your Mumbai to outstation trip. Enjoy a comfortable and reliable taxi service with flexible options."
            }
        ],
        "tableData": [
            ["Mumbai Outstation Cab Service", "Book Outstation Taxi from Mumbai"],
            ["Affordable Outstation Cabs from Mumbai", "Private Outstation Taxis from Mumbai"],
            ["One-Way Outstation Cabs from Mumbai", "Round Trip Outstation Cabs from Mumbai"],
            ["Group Travel in Outstation Cabs from Mumbai", "Comfortable Outstation Travel by Taxi from Mumbai"],
            ["Mumbai to Outstation Trip by Taxi", "Affordable Outstation Cabs from Mumbai"]
        ],




        "whychoose": [
            {
                "WhyChooseheading": "Reliable and On-Time Service",
                "WhyChoosedescription": "At S9 Travels, we ensure that your outstation trip from Mumbai is on time and hassle-free. Whether you’re heading to another city or exploring nearby destinations, our drivers are punctual, and we guarantee a smooth, timely ride to your destination."
            },
            {
                "WhyChooseheading": "Comfortable and Spacious Vehicles",
                "WhyChoosedescription": "Our Toyota Innova is perfect for outstation travel from Mumbai. With spacious seating, air conditioning, and plenty of space for luggage, you'll enjoy a relaxing and comfortable journey. Whether you're traveling solo or with family or friends, our vehicles ensure you travel in comfort throughout your trip."
            },
            {
                "WhyChooseheading": "Experienced and Professional Drivers",
                "WhyChoosedescription": "Our experienced drivers are familiar with all the best routes for outstation travel from Mumbai. They are courteous, professional, and committed to ensuring your journey is safe, smooth, and enjoyable. You can relax and focus on the journey while our drivers handle the road."
            },
            {
                "WhyChooseheading": "Affordable and Transparent Pricing",
                "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your outstation cab from Mumbai. You’ll receive a clear breakdown of all costs before confirming your booking, with no hidden charges, allowing you to plan your travel budget confidently."
            },
            {
                "WhyChooseheading": "Safe and Comfortable Journey",
                "WhyChoosedescription": "Your safety is our top priority. Our Toyota Innova vehicles come equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring you have a secure and comfortable ride throughout your outstation trip from Mumbai."
            },
            {
                "WhyChooseheading": "24/7 Availability",
                "WhyChoosedescription": "S9 Travels is available 24/7 for your outstation travel needs. Whether you’re planning an early morning departure or a late-night journey, we ensure your ride is ready, and our customer service team is available around the clock to assist you with your bookings."
            },
            {
                "WhyChooseheading": "Hassle-Free Booking Process",
                "WhyChoosedescription": "Booking your outstation cab from Mumbai is easy with S9 Travels. You can book online through our website or mobile app, or you can contact our customer service team for personalized assistance in booking your cab. We make the process simple and convenient."
            },
            {
                "WhyChooseheading": "Customized Travel Packages",
                "WhyChoosedescription": "If you have specific needs for your outstation trip, we offer customized travel packages. Whether you need additional stops, specific routes, or any other preferences, we can tailor the trip to meet your requirements and ensure a pleasant journey."
            }
        ]







    }



    const faqData = [
        [
            {
                question: 'How can I book an outstation cab from Mumbai with S9 Travels?',
                answer: 'Booking an outstation cab from Mumbai is easy! You can book your ride online through our website or mobile app, or contact our customer service team for assistance with your booking.'
            },
            {
                question: 'What types of outstation cabs are available for travel from Mumbai?',
                answer: 'We offer a variety of vehicles, including the spacious Toyota Innova, perfect for families, groups, or passengers with a lot of luggage. Choose the vehicle that best suits your needs for a comfortable journey to your outstation destination.'
            },
            {
                question: 'Are the drivers experienced for outstation travel from Mumbai?',
                answer: 'Yes, our drivers are highly experienced and familiar with the best routes for outstation travel from Mumbai. They ensure a smooth, safe, and timely journey to your destination.'
            },
            {
                question: 'What payment options are available for booking outstation cabs from Mumbai?',
                answer: 'We offer flexible payment options, including cash, credit/debit cards, and secure online payments via our mobile app, providing convenience and ease of payment for your outstation trip.'
            },
            {
                question: 'Can I book a round trip for an outstation journey from Mumbai?',
                answer: 'Yes, we offer round-trip bookings for outstation travel. Just provide us with your return details, and we’ll arrange a smooth and comfortable ride back to Mumbai from your outstation destination.'
            },
            {
                question: 'Are there any extra charges for detours or waiting time during the outstation trip?',
                answer: 'Any extra charges for detours or waiting time during your outstation trip will be communicated to you upfront, ensuring full transparency in the pricing structure.'
            },
            {
                question: 'Can I make additional stops along the way during my outstation trip from Mumbai?',
                answer: 'Yes, you can request additional stops during your outstation trip. Please inform us during the booking process, and we’ll accommodate your requests for detours or stops along the way.'
            },
            {
                question: 'What is the luggage allowance for an outstation cab from Mumbai?',
                answer: 'The Toyota Innova offers plenty of space for standard luggage. If you have more luggage or specific requirements, please inform us during the booking process, and we will make the necessary arrangements.'
            },
            {
                question: 'Does S9 Travels provide corporate travel services for outstation trips from Mumbai?',
                answer: 'Yes, we offer corporate travel services for business trips from Mumbai to outstation destinations, ensuring a professional, comfortable, and timely service for your business travel needs.'
            },
            {
                question: 'Why should I choose S9 Travels for my outstation cab booking from Mumbai?',
                answer: 'S9 Travels offers a reliable, safe, and comfortable ride with professional drivers, well-maintained vehicles, and excellent customer service, ensuring a smooth and enjoyable outstation journey from Mumbai.'
            }
        ]
    ];

    const testimonialsData = [
        {
            name: 'Mr. Rohit Kumar',
            designation: 'Customer',
            rating: [1, 1, 1, 1, 1],
            text: '“I booked an outstation cab from Mumbai with S9 Travels, and the experience was outstanding. The driver was professional, the vehicle was clean and comfortable, and the journey was smooth. Highly recommend S9 Travels for anyone needing an outstation ride from Mumbai!”'
        },
        {
            name: 'Mrs. Priya Saxena',
            designation: 'Customer',
            rating: [1, 1, 1, 1, 1],
            text: '“I used S9 Travels for an outstation trip from Mumbai, and it was a fantastic experience. The vehicle was spacious, the driver was courteous, and everything went smoothly. I’ll definitely use S9 Travels again for future outstation trips.”'
        }
    ];



































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai Outstation Cabs",
        "description": "Book reliable and affordable Mumbai outstation cabs with S9 Travels. Whether you need a ride for a weekend getaway, business trip, or long-distance travel, our professional drivers ensure a comfortable and safe journey. Choose from one-way or round-trip options with well-maintained vehicles and flexible schedules.",
        "aggregateRating": {
            "@type": "AggregateRating",
            "bestRating": "5",
            "worstRating": "1",
            "ratingValue": "4.9",
            "ratingCount": "8546"
        }
    };


    return (
        <div>

            <Helmet>
                <title>Mumbai Outstation Cabs | Comfortable & Affordable Taxi Services | S9 Travels</title>
                <meta
                    name="description"
                    content="Book your Mumbai outstation cab with S9 Travels. Enjoy a safe, comfortable, and affordable ride for long-distance travel with professional drivers. Choose from one-way or round-trip options for a hassle-free outstation journey."
                />

                {/* Inject JSON-LD Schema */}
                <script type="application/ld+json">
                    {JSON.stringify(productSchema)}
                </script>
            </Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>



            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/96.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br />
                                                        Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaioutstationcab;